import { INGXLoggerConfig } from 'ngx-logger';
import { environment } from '../../../environments/environment';

export const loggerConfig: INGXLoggerConfig = {
  level: environment.browserLogLevel,
  serverLogLevel: environment.serverLogLevel,
  disableConsoleLogging: environment.disableConsoleLogging, // disabled in prod
  timestampFormat: 'full',
};
